import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'header.links.courses': {
    id: 'header.links.courses',
    defaultMessage: 'การรับรองสมรรถนะ',
    description: 'Link to the learner course dashboard',
  },
  'header.links.programs': {
    id: 'header.links.programs',
    defaultMessage: 'โปรแกรม',
    description: 'Link to the learner program dashboard',
  },
  'header.links.content.search': {
    id: 'header.links.content.search',
    defaultMessage: 'การรับรองสมรรถนะทั้งหมด',
    description: 'Link to the content search page',
  },
  'header.links.schools': {
    id: 'header.links.schools',
    defaultMessage: 'Schools & Partners',
    description: 'Link to the schools and partners landing page',
  },
  'header.user.menu.dashboard': {
    id: 'header.user.menu.dashboard',
    defaultMessage: 'แดชบอร์ด',
    description: 'Link to the user dashboard',
  },
  'header.user.menu.profile': {
    id: 'header.user.menu.profile',
    defaultMessage: 'โปรไฟล์',
    description: 'Link to the user profile',
  },
  'header.user.menu.account.settings': {
    id: 'header.user.menu.account.settings',
    defaultMessage: 'บัญชี',
    description: 'Link to account settings',
  },
  'header.user.menu.order.history': {
    id: 'header.user.menu.order.history',
    defaultMessage: 'Order History',
    description: 'Link to order history',
  },
  'header.user.menu.logout': {
    id: 'header.user.menu.logout',
    defaultMessage: 'ออกจากระบบ',
    description: 'Logout link',
  },
  'header.user.menu.login': {
    id: 'header.user.menu.login',
    defaultMessage: 'เข้าสู่ระบบ',
    description: 'Login link',
  },
  'header.user.menu.register': {
    id: 'header.user.menu.register',
    defaultMessage: 'ลงทะเบียน',
    description: 'Link to registration',
  },
  'header.user.menu.studio.home': {
    id: 'header.user.menu.studio.home',
    defaultMessage: 'Studio Home',
    description: 'Link to the Studio Home',
  },
  'header.user.menu.studio.maintenance': {
    id: 'header.user.menu.studio.maintenance',
    defaultMessage: 'Maintenance',
    description: 'Link to the Studio Maintenance',
  },
  'header.label.account.nav': {
    id: 'header.label.account.nav',
    defaultMessage: 'บัญชี',
    description: 'The aria label for the account menu nav',
  },
  'header.label.account.menu': {
    id: 'header.label.account.menu',
    defaultMessage: 'เมนูบัญชี',
    description: 'The aria label for the account menu trigger',
  },
  'header.label.account.menu.for': {
    id: 'header.label.account.menu.for',
    defaultMessage: 'เมนูบัญชีสำหรับ {username}',
    description: 'The aria label for the account menu trigger when the username is displayed in it',
  },
  'header.label.main.nav': {
    id: 'header.label.main.nav',
    defaultMessage: 'หลัก',
    description: 'The aria label for the main menu nav',
  },
  'header.label.main.menu': {
    id: 'header.label.main.menu',
    defaultMessage: 'เมนูหลัก',
    description: 'The aria label for the main menu trigger',
  },
  'header.label.main.header': {
    id: 'header.label.main.header',
    defaultMessage: 'หลัก',
    description: 'The aria label for the main header',
  },
  'header.label.secondary.nav': {
    id: 'header.label.secondary.nav',
    defaultMessage: 'รอง',
    description: 'The aria label for the seconary nav',
  },
  'header.label.skip.nav': {
    id: 'header.label.skip.nav',
    defaultMessage: 'ข้ามไปที่เนื้อหาหลัก',
    description: 'A link used by screen readers to allow users to skip to the main content of the page.',
  },
  'header.label.app.nav': {
    id: 'header.label.app.nav',
    defaultMessage: 'แอป',
    description: 'The aria label for the app Nav',
  },
});

export default messages;
